import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { enviroments } from 'utils/constants';
import { FavoritesInterface } from 'redux/slices/favoritesSlice';
import { getLocalStorageLanguage } from 'utils/utils';

const CURRENT_LANGUAGE = getLocalStorageLanguage();
export const favoritesServiceApi = createApi({
  reducerPath: 'favoritesServiceApi',
  baseQuery: fetchBaseQuery({
    baseUrl: enviroments.endPoint,
    prepareHeaders: (headers, { getState, endpoint }) => {
      headers.set(
        'Authorization',
        'Bearer ' + JSON.parse(localStorage.getItem('userAccountInformation') || '{}').bearerToken,
      );
      return headers;
    },
  }),
  endpoints: (builder) => ({
    GetFavorites: builder.query<any, void>({
      query: () => 'favorite/',
    }),

    PostFavorites: builder.mutation<any, any>({
      query: (params: FavoritesInterface) => ({
        url: 'favorite/',
        method: 'POST',
        body: params,
      }),
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {}
      },
    }),

    DeleteFavorites: builder.mutation<any, any>({
      query: (params: FavoritesInterface) => ({
        url: 'favorite/',
        method: 'DELETE',
        body: params,
      }),
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {}
      },
    }),
    GetCategoryFavorites: builder.query<any, string>({
      query: (language = CURRENT_LANGUAGE) => `favorite/category?locale=${language}`,
    }),
  }),
});

export const {
  useLazyGetFavoritesQuery,
  usePostFavoritesMutation,
  useDeleteFavoritesMutation,
  useLazyGetCategoryFavoritesQuery,
} = favoritesServiceApi;
